import React, { useState } from "react";
import "./OrderPopup.css";

function OrderPopup({ product, closePopup }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [pin, setPin] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone", phone);
    formData.append("address", address);
    formData.append("pin", pin);
    formData.append("state", state);
    formData.append("city", city);
    formData.append("price", product.price);
    formData.append("product", product.name);

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbym0wMdlrKWiak8XTt6ub-FnsYB9a2zcf8i2p1z_JSo2f5uF-oH4x1Lu3OIqV-Xv4X8/exec",
        {
          method: "POST",
          body: formData,
        }
      );

      alert("✅ Order Sent Successfully!");
      closePopup();

    } catch (error) {
      alert("❌ Something went wrong. Please try again.");
      console.error(error);
    }
  };

  return (
    <div className="popup-overlay" onClick={closePopup}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>

        <button className="popup-close" onClick={closePopup}>✖</button>

        <h2>Order Now</h2>

        <div className="popup-product">
          <img src={product.image} alt={product.name} />
          <div>
            <p><b>{product.name}</b></p>
            <p>Price: Rs. {product.price}</p>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <input value={name} onChange={(e)=>setName(e.target.value)} placeholder="Your Name" required />
          <input value={phone} onChange={(e)=>setPhone(e.target.value)} placeholder="Phone Number" required />
          <input value={address} onChange={(e)=>setAddress(e.target.value)} placeholder="Full Address" required />
          <input value={pin} onChange={(e)=>setPin(e.target.value)} placeholder="Pin Code" required />
          <input value={state} onChange={(e)=>setState(e.target.value)} placeholder="State" required />
          <input value={city} onChange={(e)=>setCity(e.target.value)} placeholder="City" required />

          <button type="submit" className="submit-btn">
            BUY IT NOW — Rs. {product.price}
          </button>
        </form>
      </div>
    </div>
  );
}

export default OrderPopup;
